// extracted by mini-css-extract-plugin
module.exports = {"preloader":"preloader__PB4Ue","absolute":"absolute__Njia3","fixed":"fixed__cYsMK","rotate":"rotate__zlOzf","blink":"blink__7N690","fadeIn":"fadeIn__JSYmV"};